import { toast } from 'react-hot-toast';

function msgError(msg) {
    toast.error(
        <div className='container-fluid overflow-auto'>
            <div className='text-light fw-bold' style={{ fontSize: '24px' }}>Error</div>
            <hr className='text-light m-0 p-0'></hr>
            <div className='overflow-auto'>
                <p className='text-light fw-bold' style={{ fontSize: '20px' }}>{msg}</p>
            </div>
        </div>,
        {
            icon: <span style={{ fontSize: '50px', color: '#fdc1c1' }}><i className="fa-solid fa-skull-crossbones"></i></span>,
            style: {
                border: 'dashed 1px',
                borderColor: '#ffcaca',
                borderRadius: '10px',
                background: '#ee1111',
                color: '#fff',
            },
            duration: 4000
        });
}

function msgCorrecto(msg) {
    toast.success(
        <div className='container-fluid'>
            <div className='text-light fw-bold' style={{ fontSize: '24px' }}>Correcto</div>
            <hr className='text-light m-0 p-0'></hr>
            <div className=''>
                <div className='text-light fw-bold' style={{ fontSize: '20px' }}>{msg}</div>
            </div>
        </div>
        ,
        {
            icon: <span style={{ fontSize: '50px', color: '#dafdc1' }}><i className="fa-solid fa-check-double"></i></span>,
            style: {
                border: 'dashed 1px',
                borderColor: '#e3fcd1',
                borderRadius: '10px',
                background: '#0e943e',
                color: '#fff',
            },
            duration: 4000
        });
}
function msgAdvertencia(msg) {
    toast(
        <div className='container-fluid'>
            <div className='text-light fw-bold' style={{ fontSize: '24px' }}>Información</div>
            <hr className='text-light m-0 p-0'></hr>
            <div className=''>
                <div className='text-light fw-bold' style={{ fontSize: '20px' }}>{msg}</div>
            </div>
        </div>
        ,
        {
            icon: <span style={{ fontSize: '50px', color: '#e8ce09' }}><i className="fa-solid fa-triangle-exclamation"></i></span>,
            style: {
                border: 'dashed 1px',
                borderColor: '#dbdada',
                borderRadius: '10px',
                background: '#646464',
                color: '#fff',
            },
            duration: 4000
        });
}
export default { msgCorrecto, msgError,msgAdvertencia };
